import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrderItemComponent} from './order-item.component';
import {PriceDetailsTooltipComponent} from './price-details-tooltip/price-details-tooltip.component';
import {MetricTextModule} from '@app/shared/metric-text/metric-text.module';
import {I18nModule, UrlModule} from '@spartacus/core';
import {ErrorIndicatorModule} from '@app/shared/error-indicator/error-indicator.module';
import {NgDesignSystemModule} from 'ng-design-system';
import {DeploymentSystemsModule} from '@app/shared/deployment-systems/deployment-systems.module';
import {CommonConfiguratorModule, ConfigureCartEntryModule} from '@spartacus/product-configurator/common';
import {OutletModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {CpsPriceDetailsTooltipComponent} from './cps-price-details-tooltip/cps-price-details-tooltip.component';
import {DcpConfiguratorCartEntryInfoModule, DcpDateFormatterModule} from '@dcp/configurator';
import {DefaultModalModule} from '@app/shared/modal/default-modal.module';

@NgModule({
  declarations: [
    OrderItemComponent,
    PriceDetailsTooltipComponent,
    CpsPriceDetailsTooltipComponent,
  ],
  imports: [
    CommonModule,
    MetricTextModule,
    I18nModule,
    DcpDateFormatterModule,
    ErrorIndicatorModule,
    NgDesignSystemModule,
    DeploymentSystemsModule,
    CommonConfiguratorModule,
    OutletModule,
    UrlModule,
    RouterModule,
    ConfigureCartEntryModule,
    DefaultModalModule,
    DcpConfiguratorCartEntryInfoModule,
  ],
  exports: [
    OrderItemComponent,
    PriceDetailsTooltipComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class OrderItemModule {
}
